import { Search } from "@mui/icons-material";
import { Box,InputAdornment, TextField } from "@mui/material";

function TableHeaderLayout({ globalFilter, setGlobalFilter, children }) {
  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          backgroundColor: "white",
          mb: 2,
          borderRadius: 1,
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <TextField
            placeholder="Search record..."
            id="po_search"
            type="text"
            value={globalFilter || ""}
            size="small"
            onChange={(e) => setGlobalFilter(e.target.value)}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <Search />
                </InputAdornment>
              ),
            }}
          />

          {children}
        </Box>
      </Box>
    </>
  );
}

export default TableHeaderLayout;
